import { OrganizationSelectTypePage } from "@/features/organization/pages/OrganizationSelectType";

const OrganizationTypeSelect = () => {
  return <OrganizationSelectTypePage />;
};

export default OrganizationTypeSelect;
